import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
export function HeroSection() {
  return <section id="home" className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden bg-brand-black" data-id="element-127">
      {/* Background Elements */}
      <div className="absolute inset-0 grid-pattern opacity-30" data-id="element-128"></div>

      {/* Animated Orbs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-129">
        {[...Array(4)].map((_, i) => <motion.div key={i} className="absolute rounded-full bg-brand-primary/20 blur-[100px]" style={{
        width: Math.random() * 400 + 200,
        height: Math.random() * 400 + 200,
        top: `${Math.random() * 100}%`,
        left: `${Math.random() * 100}%`
      }} animate={{
        y: [0, -50, 0],
        x: [0, 30, 0],
        scale: [1, 1.1, 1]
      }} transition={{
        duration: Math.random() * 10 + 15,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-130" />)}
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="inline-block mb-4 px-4 py-1.5 rounded-full border border-brand-primary/30 bg-brand-primary/10 backdrop-blur-sm" data-id="element-132">
          <span className="text-brand-light text-sm font-semibold tracking-wide uppercase" data-id="element-133">
            Kenya's AI-First Enterprise
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-5xl md:text-7xl font-bold text-white tracking-tight mb-6 leading-tight" data-id="element-134">
          Transforming African Enterprises <br className="hidden md:block" data-id="element-135" />
          with{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-light to-brand-primary" data-id="element-136">
            Intelligent AI Solutions
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="mt-4 text-xl md:text-2xl text-gray-400 max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-137">
          SpringLinks Solutions delivers generative AI, intelligent automation,
          and custom AI development that drives measurable business
          transformation.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6,
        ease: 'easeOut'
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-138">
          <a href="#services" className="w-full sm:w-auto px-8 py-4 bg-brand-primary hover:bg-brand-light text-white rounded-full font-semibold transition-all duration-300 hover:glow-blue text-lg" data-id="element-139">
            Explore Our Solutions
          </a>
          <a href="#contact" className="w-full sm:w-auto px-8 py-4 bg-transparent border border-white/30 hover:border-white hover:bg-white/5 text-white rounded-full font-semibold transition-all duration-300 text-lg" data-id="element-140">
            Get in Touch
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-gray-500" data-id="element-141">
        <span className="text-xs uppercase tracking-widest" data-id="element-142">Scroll</span>
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 1.5,
        ease: 'easeInOut'
      }} data-id="element-143">
          <ArrowDownIcon className="w-5 h-5 text-brand-primary" data-id="element-144" />
        </motion.div>
      </motion.div>

      {/* Bottom Gradient Overlay */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-brand-black to-transparent pointer-events-none" data-id="element-145"></div>
    </section>;
}